import React from "react";

export const GeneralDashboardModalSection = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <section className="general-dashboard-modal-section">
    <h3 className="general-dashboard-modal-section__title">{title}</h3>
    {children}
  </section>
);

export const GeneralDashboardModalDetailField = ({
  label,
  value,
  fallback,
}: {
  label: string;
  value: string | number | null | undefined;
  fallback: string;
}) => (
  <div className="general-dashboard-modal-field">
    <span className="general-dashboard-modal-field__label">{label}</span>
    <span className="general-dashboard-modal-field__value">
      {value === null || value === undefined || value === "" ? fallback : value}
    </span>
  </div>
);
